import { render } from "./evattend.vue?vue&type=template&id=194754c4"
import script from "./evattend.vue?vue&type=script&lang=js"
export * from "./evattend.vue?vue&type=script&lang=js"

import "./evattend.vue?vue&type=style&index=0&id=194754c4&lang=scss"
script.render = render

export default script